import { Timestamp } from '@angular/fire/firestore';
import { FormControl } from '@angular/forms';
import { FireStoreDocument } from '@shared/models/firestore';
import { IMobileNumber } from '@shared/models/numbers';

export interface IUser extends FireStoreDocument {
	uid: string;
	displayName: string | null;
	email: string | null;
	phoneNumber: IMobileNumber;
	photoUrl: string | null;
	settings: IUserSettings;
	createdAt: Timestamp;
	updatedAt: Timestamp;
}

export interface IUserSettingsForm {
	displayName: FormControl<string | null>;
	email: FormControl<string | null>;
	emailVerified: FormControl<boolean | null>;
	phoneNumber: FormControl<IMobileNumber | null>;
}

export interface INotificationSettingsForm {
	notificationsEnabled: FormControl<boolean | null>;
	newLeads: FormControl<boolean | null>;
	assessmentStatus: FormControl<boolean | null>;
	assignedLeadAssessment: FormControl<boolean | null>;
}

export interface IUserSettings {
	notifications: INotificationSettings;
}

export interface INotificationSettings {
	notificationsEnabled: boolean;
	newLeads: boolean;
	assessmentStatus: boolean;
	assignedLeadAssessment: boolean;
}

export const DEFAULT_USER_SETTINGS: IUserSettings = {
	notifications: {
		notificationsEnabled: true,
		newLeads: true,
		assessmentStatus: true,
		assignedLeadAssessment: true,
	},
};
